export enum AcknowledgmentResource {
  CONDITIONS_METRICS = 'conditions_metrics',
}

export type Acknowledgment = {
  id: number;
  tinyaccount_id: string;
  resource_type: AcknowledgmentResource;
  resource_id: string;
  acknowledged_at: string;
  kit_id: string | null;
  created_at: string;
  updated_at: string;
};
